<template>
  <div>
    <LayoutHeader
      :topColor="topColor"
      bannerType="header user"
      :userActive="true"
      :height="380"
    />
    <div class="container">
      <div class="top">
        <div>个人资料修改</div>
      </div>

      <a-form
        :form="form"
        labelAlign="left"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item label="头像">
          <a-upload
            ref="upload"
            name="file"
            list-type="picture-card"
            class="avatar-uploader"
            :before-upload="beforeUpload"
            :customRequest="uploadHeadPic"
          >
            <img
              style="width: 120px; height: 120px; border-radius: 50%"
              v-if="userInfo.img_avatar_full"
              :src="userInfo.img_avatar_full"
              alt="avatar"
            />
            <img
              v-else
              style="width: 120px; height: 120px"
              src="../../assets/images/user/yh-icon-touxiang@2x.png"
            />
            <a-button style="border: none; color: #e68a8a"
              >点击上传头像</a-button
            >
          </a-upload>
        </a-form-item>

        <a-form-item label="姓名">
          <a-input
            v-decorator="[
              'name',
              {
                rules: [{ required: true, message: '请输入姓名！' }],
              },
            ]"
            type="text"
            placeholder="请输入您的姓名"
          >
          </a-input>
        </a-form-item>

        <a-form-item label="笔名/艺名">
          <a-input v-decorator="['stage_name']" type="text" placeholder="">
          </a-input>
        </a-form-item>

        <a-form-item label="性别">
          <a-radio-group
            v-decorator="[
              'sex',
              {
                initialValue: 1,
              },
            ]"
            name="sex"
          >
            <a-radio :value="1" style="margin-right: 40px"> 男 </a-radio>
            <a-radio :value="0"> 女</a-radio>
          </a-radio-group>
        </a-form-item>

        <a-form-item label="民族">
          <a-select
            placeholder="请选择"
            v-decorator="['nation']"
            style="width: 240px"
          >
            <a-select-option
              v-for="(nation_item, nation_index) in nationList"
              :key="nation_index"
              :value="nation_item.id"
            >
              {{ nation_item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="籍贯">
          <a-cascader
            v-decorator="['nation_place']"
            :options="areaOptions"
            :load-data="loadData"
            placeholder="请选择"
            change-on-select
          />
        </a-form-item>

        <a-form-item label="出生日期">
          <a-date-picker
            valueFormat="YYYY-MM-DD"
            v-decorator="['birthday']"
            :locale="locale"
          />
        </a-form-item>

        <a-form-item label="电话号码">
          <a-input
            v-decorator="[
              'mobile',
              {
                rules: [
                  { required: true, message: '请输入手机号!' },
                  {
                    pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                    message: '请输入正确的手机号',
                  },
                ],
              },
            ]"
            type="text"
            placeholder=""
          >
          </a-input>
        </a-form-item>

        <a-form-item label="收件地址">
          <a-input
            v-decorator="[
              'address_receipt',
              {
                rules: [{ required: true, message: '请输入收件地址!' }],
              },
            ]"
            type="text"
            placeholder=""
          >
          </a-input>
        </a-form-item>

        <a-form-item label="简介">
          <a-textarea
            v-decorator="[
              'synopsis',
              {
                rules: [{ required: true, message: '请输入简介!' }],
              },
            ]"
            style="resize: none"
            placeholder="留下一段自己的简介吧~~"
            :auto-size="{ minRows: 6 }"
            :rows="4"
          />
        </a-form-item>

        <a-form-item>
          <div class="cancel" @click="back">取消</div>
          <div class="saveData" html-type="submit" @click="handleSubmit">
            保存
          </div>
        </a-form-item>
      </a-form>
    </div>
    <LayoutFooter />
  </div>
</template>

<script>
import UserServices from "../../xx-vue/services/user";
import SystemServices from "../../xx-vue/services/system";
import Storage from "../../xx-vue/utils/storage";
export default {
  data() {
    return {
      topColor: "background-color: rgba(0, 0, 0, 0.3)",
      userInfo: {
        img_avatar_full: "",
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 },
      },
      loading: false,
      imageUrl: "", //图片地址
      imageUrl_full: "", //图片完整地址
      areaOptions: [], //区域列表
      nationList: [], //民族列表
      locale: {
        //日期中文
        lang: {
          placeholder: "请选择日期",
          today: "今天",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
        },
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "editData" });
  },
  mounted() {
    this.initScroll();
    this.initForm();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.listenerFunction);
  },
  methods: {
    //初始化滚动条监听
    initScroll() {
      document.addEventListener("scroll", this.handleScroll, true);
    },
    //监听滚动条移动
    handleScroll() {
      const pageY = window.pageYOffset;
      if (pageY === 0) {
        this.topColor = "background-color: rgba(0, 0, 0, 0.3)";
      } else {
        this.topColor = "background-color: rgb(22,22,22)";
      }
    },
    //表单提交
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          values.img_avatar = this.userInfo.img_avatar;
          const nation_place = values.nation_place
            .map((v) => {
              return v;
            })
            .join(",");
          values.nation_place = nation_place;
          const result = await UserServices.editUserAsync(values);
          if (result.code == 200) {
            this.$message.success("修改成功！");
            const userInfo = await UserServices.getCurrentUserAsync();
            let session = Storage.getStorage();
            session.info = userInfo.data;
            Storage.setStorage(session);
            this.$router.push("/user");
          }
        }
      });
    },
    //上传检测
    beforeUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isLt2M) {
      //   this.$message.error("图片大小必须小于2M");
      // }
      // return false;
    },
    //区域懒加载
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      const pid = targetOption.id;
      targetOption.loading = true;
      // 懒加载请求
      setTimeout(async () => {
        targetOption.loading = false;
        let result = await SystemServices.getAreaAsync({ pid: pid });
        let data = result.data.list;
        data = data.map((v) => {
          return { ...v, value: v.id, label: v.name, isLeaf: v.hasChildren };
        });
        targetOption.children = data;
        this.areaOptions = [...this.areaOptions];
      }, 100);
    },
    //获取用户详情
    async initUserInfo(areaOptions) {
      const result = await UserServices.getCurrentUserAsync();
      if (result.code === 200) {
        this.userInfo = result.data;
        if (result.data.nation_place !== "") {
          result.data.nation_place = result.data.nation_place
            .split(",")
            .map((v) => {
              return ~~v;
            });
        }
        if (result.data.nation === "") {
          this.form.setFieldsValue({
            nation: result.data.nation,
          });
        } else {
          this.form.setFieldsValue({ nation: ~~result.data.nation });
        }
        if (result.data.nation_place !== "") {
          this.form.setFieldsValue({ nation_place: result.data.nation_place });
        }
        this.form.setFieldsValue({
          name: result.data.name,
          stage_name: result.data.stage_name,
          sex: result.data.sex,
          birthday: result.data.birthday,
          mobile: result.data.mobile,
          address_receipt: result.data.address_receipt,
          synopsis: result.data.synopsis,
        });
        console.log(result.data);
        if (result.data.nation_place !== "") {
          const firstOption = areaOptions.filter(
            (v) => v.id === result.data.nation_place[0]
          );
          this.loadData(firstOption);
        }
      }
    },
    //初始化表单选项
    async initForm() {
      const nationResult = await SystemServices.getNationAsync();
      if (nationResult.code === 200) {
        this.nationList = nationResult.data.data;
      }

      const areaResult = await SystemServices.getAreaAsync({
        pid: 0,
      });
      if (areaResult.code === 200) {
        this.areaOptions = areaResult.data.list;
        this.areaOptions = this.areaOptions.map((v) => {
          return { ...v, value: v.id, label: v.name, isLeaf: !v.hasChildren };
        });
        this.initUserInfo(this.areaOptions);
      }
    },
    //上传头像
    async uploadHeadPic(obj) {
      const formData = new FormData();
      formData.append("file", obj.file);
      const result = await SystemServices.uploadPicAsync(formData);
      this.userInfo.img_avatar = result.data.path;
      this.userInfo.img_avatar_full = result.data.path_full;
    },
    //取消
    back() {
      this.$router.push("/user");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-upload-list-picture-card-container {
  display: none;
}

/deep/ .ant-form-item label {
  color: #656565;
}
/deep/ .ant-upload.ant-upload-select-picture-card {
  background-color: unset;
  border: none;
}
/deep/ .ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
  display: flex;
  align-items: center;
}
/deep/ .ant-upload-picture-card-wrapper {
  width: 135px;
}
/deep/ .ant-input {
  border: none;
  height: unset;
  background-color: #f6f6f6;
  padding-top: 14px;
  padding-bottom: 14px;
  font-size: 18px;
  color: #989898;
  text-indent: 10px;
}
/deep/ .ant-select-selection--single {
  color: #989898;
  height: unset;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
}

/deep/ .ant-cascader-picker {
  border: 1px solid #e6e7e8;
  width: 240px;
  color: #989898;
}

/deep/ .ant-calendar-picker-input.ant-input {
  width: 240px;
  background-color: white;
  border: 1px solid #e6e7e8;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
  .top {
    border-bottom: 2px solid #e6e7e8;
    margin-bottom: 24px;
    div {
      margin-left: 20px;
      width: 140px;
      text-align: center;
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      padding-bottom: 10px;
      border-bottom: 2px solid #e24141;
    }
  }

  .cancel {
    background: url("../../assets/images/user/yh-bt-cancel@2x.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    color: white;
    width: 146px;
    height: 56px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-left: 94px;
  }

  .saveData {
    background: url("../../assets/images/user/yh-bt-normol@2x.png") no-repeat;
    background-size: 100% 100%;
    display: inline-block;
    color: white;
    width: 146px;
    height: 56px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    margin-left: 100px;
  }
}
</style>
